// File: frontend-new/src/config/environment.js
// Environment-aware configuration for API URLs and other settings

// Environment detection
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';
const isTest = process.env.NODE_ENV === 'test';

// API Base URL configuration with fallbacks
const getApiBaseUrl = () => {
  // Priority order:
  // 1. REACT_APP_API_URL environment variable (for production)
  // 2. Local development proxy
  // 3. Production fallback
  
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/+$/, ''); // Remove trailing slashes
  }
  
  if (isDevelopment) {
    return 'http://localhost:5000'; // Local development
  }
  
  if (isTest) {
    return 'https://intranet.nesimltd.co.ke'; // Test environment
  }
  
  // Production fallback
  return 'https://intranet.nesimltd.co.ke';
};

// Configuration object
const config = {
  // Environment
  isDevelopment,
  isProduction,
  isTest,
  
  // API Configuration
  api: {
    baseUrl: getApiBaseUrl(),
    timeout: isProduction ? 30000 : 60000, // 30s prod, 60s dev
    retries: 3,
    retryDelay: 1000
  },
  
  // Upload Configuration
  upload: {
    maxFileSize: isProduction ? 10 * 1024 * 1024 : 20 * 1024 * 1024, // 10MB prod, 20MB dev
    maxFiles: 5,
    allowedTypes: [
      'image/jpeg', 'image/png', 'image/gif', 'image/webp',
      'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'text/plain', 'text/csv', 'application/csv',
      'application/zip', 'application/x-rar-compressed'
    ]
  },
  
  // Feature Flags
  features: {
    enableLogging: isDevelopment || process.env.REACT_APP_ENABLE_LOGGING === 'true',
    enableDebugTools: isDevelopment || process.env.REACT_APP_ENABLE_DEBUG_TOOLS === 'true',
    enableFileUpload: true,
    enableRealTimeChat: true,
    enableWorkflowAutomations: true
  },
  
  // Security
  security: {
    httpsOnly: isProduction,
    enableCSP: isProduction
  }
};

// Log configuration in development
if (isDevelopment) {
  console.log('🔧 Environment Configuration:', {
    NODE_ENV: process.env.NODE_ENV,
    API_BASE_URL: config.api.baseUrl,
    isDevelopment,
    isProduction,
    isTest,
    features: config.features
  });
}

export default config;
